/** @format */

export const industryNavigationMenu = [
    {
        key: "EzMarketing_TimeTracking_Janitorial",
        title: 'Janitorial',
        link: '/time-tracking/janitorial-cleaning-services-gps/index.html',
    },
    {
        key: "EzMarketing_TimeTracking_Contractors",
        title: 'Contractors',
        link: '/time-tracking/contractors.html',
    },
    {
        key: "EzMarketing_TimeTracking_LandscapeLawnCare",
        title: 'Landscape Lawn Care',
        link: '/time-tracking/landscape-lawn-care-service-gps/index.html',
    },
    {
        key: "EzMarketing_TimeTracking_HomeCare",
        title: 'Home Care',
        link: '/time-tracking/homecare-app/index.html',
    },
    {
        key: "EzMarketing_TimeTracking_Construction",
        title: 'Construction',
        link: '/time-tracking/construction-gps/index.html',
    },
    {
        key: "EzMarketing_TimeTracking_PropertyManagement",
        title: 'Property Management',
        link: '/time-tracking/property-management-gps/index.html',
    },
    {
        key: "EzMarketing_TimeTracking_OtherSmallBusiness",
        title: 'Other Small Business',
        link: '/time-tracking/small-business-gps/index.html',
    },
    {
        key: "EzMarketing_TimeTracking_Freelancers",
        title: 'Freelancers',
        link: '/time-tracking/time-clock-for-freelancers/index.html',
    },

];
